import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faNodeJs, faAws, faPython } from '@fortawesome/free-brands-svg-icons';
import { faDatabase, faRobot, faCloud, faHouse, faUserTie, faAddressCard, faPlane } from '@fortawesome/free-solid-svg-icons';

const applications = [
  { label: 'Real Estate AI', icon: faHouse },
  { label: 'Recruitment Tech', icon: faUserTie },
  { label: 'CRM Platforms', icon: faAddressCard },
  { label: 'Travel Portals', icon: faPlane },
];

const technologies = [
  { label: 'React / Next.js', icon: <FontAwesomeIcon icon={faReact} /> },
  { label: 'Node.js', icon: <FontAwesomeIcon icon={faNodeJs} /> },
  { label: 'Python / FastAPI', icon: <FontAwesomeIcon icon={faPython} /> },
  { label: 'PostgreSQL', icon: <FontAwesomeIcon icon={faDatabase} /> },
  { label: 'Cloud / AWS', icon: <FontAwesomeIcon icon={faAws} /> },
  { label: 'Applied AI / LLMs', icon: <FontAwesomeIcon icon={faRobot} /> },
];

function AppCard({ app, i }) {
  return (
    <motion.div
      className="tool-card card relative flex flex-col items-center justify-center text-center py-10 px-4 cursor-default select-none"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.5, delay: i * 0.08 }}
    >
      {app.launching && (
        <span
          className="absolute -top-3 t-label px-3 py-1 rounded-full flex items-center gap-1.5"
          style={{ backgroundColor: 'var(--accent)', color: '#17130a' }}
        >
          <span className="dot-pulse" style={{ backgroundColor: '#17130a' }} />
          Launching Soon
        </span>
      )}
      <div
        className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4"
        style={{ background: 'linear-gradient(135deg, var(--accent), var(--accent-muted))' }}
      >
        <FontAwesomeIcon icon={app.icon} className="text-xl" style={{ color: 'var(--bg)' }} />
      </div>
      <span className="t-h3 font-normal" style={{ color: 'var(--text-primary)' }}>{app.label}</span>
    </motion.div>
  );
}

export default function Build() {
  return (
    <section id="build" className="py-24 px-6 md:px-8" style={{ backgroundColor: 'var(--bg-subtle)' }}>
      <div className="container-premium">
        <div className="eyebrow mb-4">What We Build</div>
        <h2 className="t-h1 font-display mb-14" style={{ color: 'var(--text-primary)' }}>
          Industries &amp; Tooling
        </h2>

        <h3 className="t-label mb-5" style={{ color: 'var(--text-muted)' }}>Industries</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          {applications.map((app, i) => (
            <AppCard key={app.label} app={app} i={i} />
          ))}
        </div>

        <h3 className="t-label mb-5" style={{ color: 'var(--text-muted)' }}>Tool Stack</h3>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
          {technologies.map((tech, i) => (
            <motion.div
              key={tech.label}
              className="tool-card card relative flex flex-col items-center justify-center text-center py-10 px-4 cursor-default select-none"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
            >
              <div
                className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4"
                style={{ background: 'linear-gradient(135deg, var(--accent), var(--accent-muted))' }}
              >
                <span className="text-xl" style={{ color: 'var(--bg)' }}>{tech.icon}</span>
              </div>
              <span className="t-h3 font-normal" style={{ color: 'var(--text-primary)' }}>{tech.label}</span>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 card p-8 flex flex-col md:flex-row items-center justify-between gap-6" style={{ borderColor: 'var(--accent)' }}>
          <div>
            <div className="eyebrow mb-3">Coming Next</div>
            <h3 className="t-h2 mb-2" style={{ color: 'var(--text-primary)' }}>Our Real Estate AI Platform — Launching Soon</h3>
            <p className="t-body" style={{ color: 'var(--text-secondary)' }}>
              An AI-native property search and analysis platform, built by the Ufeus team. Details coming soon.
            </p>
          </div>
          <FontAwesomeIcon icon={faCloud} className="text-5xl hidden md:block" style={{ color: 'var(--accent)' }} />
        </div>
      </div>
    </section>
  );
}
